import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\External\Services\HandshakeController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandshakeController.php:12
* @route '/api/external/services/handshake'
*/
export const handshake = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: handshake.url(options),
    method: 'post',
})

handshake.definition = {
    methods: ["post"],
    url: '/api/external/services/handshake',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\External\Services\HandshakeController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandshakeController.php:12
* @route '/api/external/services/handshake'
*/
handshake.url = (options?: RouteQueryOptions) => {
    return handshake.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\External\Services\HandshakeController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandshakeController.php:12
* @route '/api/external/services/handshake'
*/
handshake.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: handshake.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\External\Services\HandoffController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandoffController.php:18
* @route '/api/external/services/handoff'
*/
export const handoff = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: handoff.url(options),
    method: 'get',
})

handoff.definition = {
    methods: ["get","head"],
    url: '/api/external/services/handoff',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\External\Services\HandoffController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandoffController.php:18
* @route '/api/external/services/handoff'
*/
handoff.url = (options?: RouteQueryOptions) => {
    return handoff.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\External\Services\HandoffController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandoffController.php:18
* @route '/api/external/services/handoff'
*/
handoff.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: handoff.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\External\Services\HandoffController::__invoke
* @see app/Http/Controllers/Api/External/Services/HandoffController.php:18
* @route '/api/external/services/handoff'
*/
handoff.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: handoff.url(options),
    method: 'head',
})

const services = {
    handshake: Object.assign(handshake, handshake),
    handoff: Object.assign(handoff, handoff),
}

export default services